import {Component, Inject, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-green-score-calc',
  templateUrl: './green-score-calc.component.html',
  styleUrls: ['./green-score-calc.component.scss']
})
export class GreenScoreCalcComponent implements OnInit {
  methods: any[];
  columns: any[];
  items: { variable: string, mg_km: number, g_km: number }[];
  selectedMethod: any = 'NEDC';
  vars: { co: number, co2: number, nox: number, pm: number, hc: number };
  greenScore: number;
  pollutionGroup: number;
  discount: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<GreenScoreCalcComponent>) {

  }

  ngOnInit(): void {
    this.vars = {
      co: 0,
      co2: 0,
      nox: 0,
      pm: 0,
      hc: 0
    };
    this.items = [
      {variable: 'co', mg_km: 0, g_km: 0},
      {variable: 'hc', mg_km: 0, g_km: 0},
      {variable: 'nox', mg_km: 0, g_km: 0},
      {variable: 'pm', mg_km: 0, g_km: 0},
      {variable: 'co2', mg_km: 0, g_km: 0},
    ];
    this.columns = [
      {header: 'משתנה', field: 'variable'},
      {header: 'mg/km', field: 'mg_km'},
      {header: 'g/km', field: 'g_km'},
    ];
    this.methods = [
      {label: 'NEDC', value: 'NEDC'},
      {label: 'WLTP', value: 'WLTP'},
    ];
  }

  calcChange($event: Event, rowData: any) {

    if (rowData) {
      switch (rowData.variable) {
        case 'nox':
          this.vars.nox = ((rowData.mg_km / 1000) + rowData.g_km) * 97458;
          break;
        case 'co2':
          this.vars.co2 = ((rowData.mg_km / 1000) + rowData.g_km) * 121;
          break;
        case 'co':
          this.vars.co = ((rowData.mg_km / 1000) + rowData.g_km) * 1346;
          break;
        case 'hc':
          this.vars.hc = ((rowData.mg_km / 1000) + rowData.g_km) * 27708;
          break;
        case 'pm':
          this.vars.pm = ((rowData.mg_km / 1000) + rowData.g_km) * 188264;
          break;
      }
    }
    let greenScore = 0.81 * ((0.323 * this.vars.co + 6.839 * this.vars.hc + 128.176 * this.vars.nox + 497.676 * this.vars.pm + 140 * this.vars.co2) / 100);
    console.log(greenScore)
    switch (this.selectedMethod) {
      case 'NEDC':
        this.greenScore = Math.round(((this.vars.nox + this.vars.co2 + this.vars.co + this.vars.hc + this.vars.pm) / 100) * 1.1);
        break;
      case 'WLTP':
        this.greenScore = Math.round(((this.vars.nox + this.vars.co2 + this.vars.co + this.vars.hc + this.vars.pm) / 100) * 0.89);
        break;
    }

    this.pollutionGroup = _.inRange(this.greenScore, 0, 50) ? 1 :
      _.inRange(this.greenScore, 51, 130) ? 2 :
        _.inRange(this.greenScore, 131, 150) ? 3 :
          _.inRange(this.greenScore, 151, 170) ? 4 :
            _.inRange(this.greenScore, 171, 175) ? 5 :
              _.inRange(this.greenScore, 176, 180) ? 6 :
                _.inRange(this.greenScore, 181, 185) ? 7 :
                  _.inRange(this.greenScore, 186, 190) ? 8 :
                    _.inRange(this.greenScore, 191, 195) ? 9 :
                      _.inRange(this.greenScore, 196, 200) ? 10 :
                        _.inRange(this.greenScore, 201, 205) ? 11 :
                          _.inRange(this.greenScore, 206, 210) ? 12 :
                            _.inRange(this.greenScore, 211, 220) ? 13 :
                              _.inRange(this.greenScore, 221, 250) ? 14 : 15;

    if (this.pollutionGroup) {
      this.discount = this.data.find(pv => pv.value === this.pollutionGroup);
    }
  }

  saveScore() {
    this.dialogRef.close({
      score: this.greenScore || 0,
      pollution: this.pollutionGroup || 0,
      discount: this.discount ? this.discount.discount : 0
    });
  }
}
